import { q, qq } from "../helper/q"

/*global google contactMap*/

export const mapInit = () => {
  console.log("map init")
  const stylesMap = [
    {
      featureType: "administrative",
      elementType: "all",
      stylers: [
        {
          saturation: "-100"
        }
      ]
    },
    {
      featureType: "administrative.province",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 65
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: "50"
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: "-100"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "all",
      stylers: [
        {
          lightness: "30"
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "all",
      stylers: [
        {
          lightness: "40"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          hue: "#ffff00"
        },
        {
          lightness: -25
        },
        {
          saturation: -97
        }
      ]
    },
    {
      featureType: "water",
      elementType: "labels",
      stylers: [
        {
          lightness: -25
        },
        {
          saturation: -100
        }
      ]
    }
  ]

  const mapElement = document.getElementById("map")
  if (mapElement) {
    const mapStores = new google.maps.Map(mapElement, {
      scrollwheel: false,
      zoom: 17,
      minZoom: 2,
      center: new google.maps.LatLng(55.755825, 37.617298),
      streetViewControl: false,
      mapTypeControl: false,
      styles: stylesMap,
      scaleControl: false,
      zoomControl: true,
      fullscreenControl: false
    })

    const bounds = new google.maps.LatLngBounds()
    const markers = {}
    const infowindow = new google.maps.InfoWindow()
    contactMap.map((item, index) => {
      markers[index] = new google.maps.Marker({
        icon: {
          url: "/local/templates/main/img/pin.svg",
          size: new google.maps.Size(56, 66),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(28, 66),
          scaledSize: new google.maps.Size(56, 66),
          labelOrigin: new google.maps.Point(56, 66)
        },
        position: new google.maps.LatLng(item.latitude, item.longitude),
        map: mapStores,
        optimized: false

        // label: { fontFamily: "lato", text: item.companyInfo.name, color: "white" }
      })

      bounds.extend(new google.maps.LatLng(item.latitude, item.longitude))

      markers[index].addListener("click", () => {
        mapStores.setZoom(16)
        mapStores.setCenter(markers[index].getPosition())
        // markers[item.id].setIcon({
        //   url: "/local/templates/ilim/img/marker-ilimtimber-green.svg",
        //   size: new google.maps.Size(41, 41),
        //   origin: new google.maps.Point(0, 0),
        //   anchor: new google.maps.Point(20, 20),
        //   scaledSize: new google.maps.Size(41, 41),
        //   labelOrigin: new google.maps.Point(41, 41)
        // })

        // infowindow.setContent(item.infoWindow)
        // infowindow.open(mapStores, markers[item.id])
        // infowindow.addListener("domready", () => {
        //   q(".infoWindow button").addEventListener("click", () => {
        //     q(".contactsSwitcherInput").checked = false
        //     infoPoser.set("open")
        //     overlayPoser.set("show")
        //     headerPoser.set("open")
        //     infowindow.close()
        //     setTimeout(() => {
        //       scroll.animateScroll(q(`.contactsBlock[data-id='${item.id}']`), { speed: 400, offset: 100 })
        //     }, 300)
        //   })
        // })
      })
    })

    mapStores.setCenter(bounds.getCenter())
    mapStores.fitBounds(bounds)

    window.addEventListener("resize", () => {
      mapStores.setCenter(bounds.getCenter())
      mapStores.fitBounds(bounds)
      mapStores.setZoom(mapStores.getZoom() - 1)
    })

    const listener = google.maps.event.addListener(mapStores, "idle", () => {
      mapStores.setZoom(mapStores.getZoom() - 1)
      google.maps.event.removeListener(listener)
    })

    const buttonsToZoom = qq(".contactsLocationButton")
    buttonsToZoom.map((button, index) => {
      button.addEventListener("click", () => {
        // infoPoser.set("closed")
        // overlayPoser.set("hide")
        // headerPoser.set("closed")
        // scroll.animateScroll(0, { speed: 400, offset: 100 })
        setTimeout(() => {
          // q(".contactsSwitcherInput").checked = true
          // markers[button.dataset.id].setIcon({
          //   url: "/local/templates/ilim/img/marker-ilimtimber-green.svg",
          //   size: new google.maps.Size(41, 41),
          //   origin: new google.maps.Point(0, 0),
          //   anchor: new google.maps.Point(20, 20),
          //   scaledSize: new google.maps.Size(41, 41),
          //   labelOrigin: new google.maps.Point(41, 41)
          // })
          mapStores.setZoom(16)
          mapStores.setCenter(markers[index].getPosition())
          // infowindow.setContent(contactMap.filter(item => item.id === button.dataset.id)[0].infoWindow)
          // infowindow.open(mapStores, markers[button.dataset.id])
          // infowindow.addListener("domready", () => {
          //   q(".infoWindow button").addEventListener("click", e => {
          //     q(".contactsSwitcherInput").checked = false
          //     infoPoser.set("open")
          //     infowindow.close()
          //     setTimeout(() => {
          //       scroll.animateScroll(q(`.contactsBlock[data-id='${e.target.dataset.id}']`), { speed: 400, offset: 100 })
          //     }, 300)
          //   })
          // })
        }, 500)
      })
    })
    q(".pageBack", mapElement.parentNode).addEventListener("click", () => {
      mapStores.setCenter(bounds.getCenter())
      mapStores.fitBounds(bounds)
    })
  }
}
